import ButtonT from '@components/tailwind-components/Button/ButtonT';
import InputWithLabelT from '@components/tailwind-components/Input/InputWithLabelT';
import { useCallback } from 'react';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { useGDPR } from '../../../hooks/gdpr/useGDPR';
import { useGDPRActions } from '../../../hooks/gdpr/useGDPRActions';
import { useModal } from '../../../hooks/modal/useModal';

export const GDPREmailPrompt = () => {
  const { handleSubmit, control } = useForm<{ email: string }>({
    defaultValues: { email: '' },
  });

  const { selectedUser } = useGDPR();
  const { sendGDPR } = useGDPRActions();

  const { hideModal } = useModal();
  const { t } = useTranslation();

  const hideAndSubmit = useCallback(
    async (data: { email: string }) => {
      if (selectedUser?.userId) {
        const { email } = data;
        sendGDPR(selectedUser?.userId, email);
      }
      hideModal();
    },
    [hideModal, selectedUser?.userId, sendGDPR],
  );

  return (
    <form
      className='tailwind-modal-form'
      onSubmit={handleSubmit(hideAndSubmit)}>
      <div className='tailwind-modal-body'>
        <p className='text-sm mb-2 italic'>
          {t('gdpr.modals.send-email-description')}
        </p>
        <div className='grid grid-cols-1 gap-x-6 gap-y-2'>
          <div className='col-span-1'>
            <InputWithLabelT
              type='email'
              field='email'
              placeholder='Email'
              label={t('auth.input.email')}
              id='email'
              control={control}
              options={{
                required: t('general.validation.required'),
              }}
            />
          </div>
        </div>
      </div>
      <div className='tailwind-modal-footer'>
        <ButtonT
          type='button'
          styling='cancel'
          size='xs'
          rounding='md'
          onClick={() => {
            hideModal();
          }}>
          {t('general.buttons.cancel')}
        </ButtonT>
        <ButtonT type='submit' styling='primary' size='xs' rounding='md'>
          {t('gdpr.modals.send-email.button.send')}
        </ButtonT>
      </div>
    </form>
  );
};
